<script setup>
import { inject, computed, onMounted, onBeforeUnmount } from 'vue'
import { hybrid } from '@dpgradio/creative'
import PollView from './components/PollView.vue'
import ResultsView from './components/ResultsView.vue'

const pollParams = inject('pollParams')

const currentView = computed(() => {
  if (pollParams.mode === 'results') {
    return ResultsView
  }
  return PollView
})

const toggleMode = (mode) => {
  pollParams.mode = mode
}

const reloadPage = () => {
  window.location.reload()
}

let resizeObserver = null

const observeScreenSize = () => {
  resizeObserver = new ResizeObserver(() => {
    const domHeight = Math.max(
      document.body.scrollHeight,
      document.body.clientHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight
    )

    hybrid.call('changeHeight', { height: domHeight, animated: false })
  })

  resizeObserver.observe(document.body)
}

onMounted(() => {
  document.documentElement.classList.add(pollParams.theme)
  observeScreenSize()
})

onBeforeUnmount(() => {
  if (resizeObserver) {
    resizeObserver.disconnect()
    resizeObserver = null
  }
})
</script>

<template>
  <div class="poll-app" :class="pollParams.theme">
    <div class="poll-app__wrapper">
      <component :is="currentView" />
    </div>
    <div v-if="pollParams.isStaging" class="poll-app__debug">
      staging: {{ pollParams.commitHash }} |
      <a href="#" @click.prevent="toggleMode('active')" :class="{ active: pollParams.mode === 'active' }">poll</a>
      /
      <a href="#" @click.prevent="toggleMode('results')" :class="{ active: pollParams.mode === 'results' }">results</a>
      |
      <a href="#" @click.prevent="reloadPage">reload</a>
    </div>
  </div>
</template>

<style scoped>
.poll-app {
  background: transparent;
  margin-left: 1rem; /* mx-4 in tailwind speak */
  margin-right: 1rem;
}

.poll-app__wrapper {
  max-width: 600px;
  margin: 0 auto;
  border: 3px solid var(--primary-color);
  overflow: hidden;
  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.2);
}

.poll-app__debug {
  text-align: center;
  padding: 0.5rem;
  font-size: 0.75rem;
  color: #999;
  font-family: monospace;
}

.poll-app__debug a {
  color: #999;
  text-decoration: none;
}

.poll-app__debug a:hover {
  color: #666;
  text-decoration: underline;
}

.poll-app__debug a.active {
  color: #333;
  font-weight: bold;
}
</style>
